<template>
  <div class="vf-confirmation">
    <div class="grid-x align-top">
      <div class="cell shrink">
        <span 
          v-html="$icons.get('check', 'xxlarge green')" 
          style="padding-right: 1rem">
        </span>
      </div>
      <div class="cell auto">
        <div v-html="displayMessage"></div>
        <!--<p style="margin-top: 2rem"><a @click.prevent="reset">Send another message</a></p>-->
      </div>
    </div> 
  </div>
</template>

<script>
var VueScrollTo = require('vue-scrollto')

export default { 
  name: 'Confirmation',
  props: {
    message: {
      type: String
    }
  },
  methods: {
    reset () {
      this.$commit.reset(true)
    }
  },
  computed: {
    displayMessage () {
      if (this.message) {
        return this.message
      }
      return '<h4>Your form has been submitted successfully. Thank you.</h4>'
    }
  },
  mounted() {
    let el = this.$root.$el
    this.$nextTick(() => {
      VueScrollTo.scrollTo(el, 100, { offset: -20 })
    })
  }
}

</script>
